<template>
  <div>
    <div
      class="fade page-sidebar-fixed page-header-fixed show page-container"
      v-if="!pageOptions.pageEmpty"
      v-bind:class="{ 
		'page-sidebar-minified': pageOptions.pageSidebarMinified, 
		'page-content-full-height': pageOptions.pageContentFullHeight, 
		'page-without-sidebar': pageOptions.pageWithoutSidebar, 
		'page-with-right-sidebar': pageOptions.pageWithRightSidebar, 
		'page-with-two-sidebar': pageOptions.pageWithTwoSidebar,
		'page-with-wide-sidebar': pageOptions.pageWithWideSidebar,
		'page-with-light-sidebar': pageOptions.pageWithLightSidebar,
		'page-with-top-menu': pageOptions.pageWithTopMenu,
		'page-sidebar-toggled': pageOptions.pageMobileSidebarToggled,
		'page-right-sidebar-toggled': pageOptions.pageMobileRightSidebarToggled || pageOptions.pageRightSidebarToggled,
		'has-scroll': pageOptions.pageBodyScrollTop
	}"
    >
      <Header />
      <TopMenu v-if="pageOptions.pageWithTopMenu" />
      <Sidebar v-if="!pageOptions.pageWithoutSidebar" />
      <SidebarRight v-if="pageOptions.pageWithTwoSidebar" />
      <div
        id="content"
        class="content"
        v-bind:class="{ 'content-full-width': pageOptions.pageContentFullWidth, 'content-inverse-mode': pageOptions.pageContentInverseMode }"
      >
        <router-view></router-view>
        <vue-ins-progress-bar></vue-ins-progress-bar>
      </div>
      <Footer v-if="pageOptions.pageWithFooter" />
    </div>
    <div v-else>
      <router-view></router-view>
      <vue-ins-progress-bar></vue-ins-progress-bar>
    </div>
  </div>
</template>

<script>
import Sidebar from "./components/sidebar/Sidebar.vue";
import SidebarRight from "./components/sidebar-right/SidebarRight.vue";
import Header from "./components/header/Header.vue";
import TopMenu from "./components/top-menu/TopMenu.vue";
import Footer from "./components/footer/Footer.vue";
import PageOptions from "./config/PageOptions.vue";

import { getToken, getStorage } from "@/libs/util";
import store from "@/store";

export default {
  name: "app",
  components: {
    Sidebar,
    SidebarRight,
    Header,
    TopMenu,
    Footer
  },
  data() {
    return {
      pageOptions: PageOptions
    };
  },
  methods: {
    handleScroll: function() {
      PageOptions.pageBodyScrollTop = window.scrollY;
    }
  },
  mounted() {
    this.$insProgress.finish();
    this.$Notice.config({
      zIndex: 1200,
      top: 50,
      duration: 3
    });
    this.$Message.config({
      top: 50,
      zIndex: 1200,
      duration: 3
    });
  },
  created() {
    PageOptions.pageBodyScrollTop = window.scrollY;

    window.addEventListener("scroll", this.handleScroll);

    this.$insProgress.start();

    this.judgeIsLogin();
    let navigator = false;
    this.$router.beforeEach((to, from, next) => {
      this.$insProgress.start();
      const token = getToken();

      if (!token) {
        if (navigator) {
          navigator = false;
          next();
        } else {
          navigator = true;
          next("/login");
        }
      } else {
        if (this.$store.state.user.userId == 0) {
          store
            .dispatch("getUserInfo")
            .then(user => {
              next();
            })
            .catch(() => {
              next({ path: "/login" });
            });
        } else {
          next();
        }
      }
    });
    this.$router.afterEach(() => {
      this.$insProgress.finish();
    });
  },
  methods: {
    judgeIsLogin() {
      const token = getToken();
      console.log(token, "token");
      if (token) {
        store
          .dispatch("reloadLoginData")
          .then(user => {})
          .catch(() => {
            setToken("");
            this.$router.push({ path: "/login" });
          });
      } else {
        const route = {
          path: "/login"
        };
        this.$router.push(route);
      }
    }
  }
};
</script>
